<template>
  <el-dialog
   title="上传"
   :width="600"
   :destroy-on-close ="true"
    v-model="dialogVisible"
  >
  <div>
     <el-upload
      class="avatar-uploader"
      action="/file_system/upload"
      :headers="config"
      :limit='1'
      :on-success="piccb"
      :file-list="fileList"
      list-type="picture">
      <el-button size="small" type="primary">点击上传封面</el-button>
    </el-upload>
  </div>
    <div style="margin-top:2%">
      <el-upload
    
      class="upload-demo"
      action="/file_system/upload"
      :file-list="videoList"
      :headers="config"
      :on-success="videocb"
      :limit='1'
      list-type="file">
      <el-button size="small" type="primary">点击上传视频</el-button>
    </el-upload>
    </div>
    <el-input style="width:50%;margin-top:10%" v-model="name" placeholder="视频名称"></el-input>
    <template #footer>
    <span class="dialog-footer">
      <el-button type="primary" @click="()=>{uploadFile();dialogVisible = false}">确 定</el-button>
    </span>
  </template>
  </el-dialog>
</template>

<script>
import { computed, reactive, ref } from 'vue';
import { postAction } from '@/libs/http';
import { ElMessage } from 'element-plus';

export default {
  emits:['ok'],
  setup(props,ctx) {

    const fileList = reactive([]);

    const videoList = reactive([]);

    const dialogVisible = ref(false);

    let name = ref(null)

    let picId = ref(null)

    let videoId = ref(null)

    const uploadFile = ()=>{
       postAction('/file_system/jkvideo/jkVideo/add',{videoBg: picId,fileId: videoId,videoName: name._value}).then((res)=>{
           if(res.status=== 200){
              ElMessage.success({
                message: res.data.message,
                type: 'success'
              });
              name.value = null
              ctx.emit('ok')
              
           }
           
       })
    };
    const piccb = (res)=>{
      picId = res.result.id
    };
    const videocb = (res)=>{
      videoId = res.result.id
      
    }
    const config = computed(()=>{
      return {'X-Access-Token' : sessionStorage.getItem('token')}
    })
    
    const show = ()=>{
      dialogVisible.value = true;
    };


    return {
      dialogVisible,
      show,
      fileList,
      videoList,
      config,
      videoId,
      picId,
      piccb,
      videocb,
      name,
      uploadFile
    }
  },
}
</script>
